import * as React from 'react';

import { AxiosResponse, AxiosError } from 'axios';

import { ClientFeedback } from '@app/pages/MainPage/ValueInclusive/Slider/ClientFeedback';
import { SpecialOffers } from '@app/pages/MainPage/ValueInclusive/Slider/SpecialOffers';
import { PersonalManager } from '@app/pages/MainPage/ValueInclusive/Slider/PersonalManager';
import { Intro } from '@app/pages/MainPage/ValueInclusive/Slider/Intro';
import { VideoSection } from '@app/pages/MainPage/ValueInclusive/Slider/VideoSection';
import { FeaturedDestination } from '@app/pages/MainPage/ValueInclusive/Slider/FeaturedDestination';
import { Subscribe } from '@app/pages/Forms/Subscribe';
import { TopPackages } from '@app/pages/MainPage/ValueInclusive/Slider/TopPackages';

import { Package } from '@app/pages/MainPage/ValueInclusive/types';
import { httpModules } from '@app/helpers/http.module';

import '@app/scss/valueInclusive/index.scss';

interface IValueInclusiveInfo {
	valueInclusives: Array<Package>;
}

export const ValueInclusive: React.FC = () => {
	const [packages, setPackages] = React.useState<Array<Package>>([]);

	React.useEffect(() => {
		httpModules
			.get<IValueInclusiveInfo>('https://www.onlinevacationcenter.com/api/pages/v1/ValueInclusive')
			.then((response: AxiosResponse<IValueInclusiveInfo>) => {
				const merged: IValueInclusiveInfo = {
					valueInclusives: response.data.valueInclusives,
				};

				setPackages(merged.valueInclusives ?? []);
			})
			.catch((error: AxiosError) => {
				console.warn(error);
			});
	}, []);

	return (
		<div className="value-inclusive">
			<Intro items={packages} />
			<TopPackages items={packages} />
			<FeaturedDestination />
			<SpecialOffers />
			<VideoSection />
			<ClientFeedback />
			<PersonalManager />
			<Subscribe />
		</div>
	);
};
